<template>
  <div class="kpi_table--column">
    <app-loading-section :loading="isLoading">
      <div class="kpi_table--column--heading">
        <p>{{ columnData.label }}</p>
      </div>

      <template v-for="(row, key) in kpiRowInfo">
        <stats-kpi-cell-data
          v-if="doesUserHaveAccess(row.permissionCheck)"
          :key="key"
          :label="row.label"
          :column-data="columnData"
          :amount="columnAmounts[key]"
          :goal="goals[key]"
          :records-endpoint="row.recordsEndpoint"
        />
      </template>
    </app-loading-section>
  </div>
</template>

<script>
import StatsKpiCellData from "./StatsKpiCellData";

export default {
  name: "StatsKpiColumnData",
  components: {StatsKpiCellData},
  props: {
    columnData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      columnAmounts: []
    }
  },
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    kpiRowInfo() {
      return this.$store.getters["statsKpi/kpiRowInfo"];
    },
    goals() {
      return this.$store.getters["statsKpi/goals"]
    },
    campaignsFilter() {
      return this.$store.state.statsKpi.filters.campaigns;
    },
    usersFilter() {
      return this.$store.state.statsKpi.filters.users;
    },
  },
  methods: {
    doesUserHaveAccess(rowPermissionCheck) {
      // If rowPermissionCheck is null then show row
      if (!rowPermissionCheck) return true;
      // If owner show all row
      if (this.authUser.is_owner) return true;
      // check if user has rowPermissionCheck
      return this.authUser[rowPermissionCheck];
    },
    async getColumnAmounts() {
      this.isLoading = true

      const payload = {
        start_at: this.columnData.startAt,
        end_at: this.columnData.endAt,
        campaigns: this.campaignsFilter,
        users: this.usersFilter
      };

      await this.$store.dispatch('statsKpi/getColumnAmounts', payload).then(response => {
        this.isLoading = false
        return this.columnAmounts = response
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_table--column {
  flex: 0 0 $kpiColumnWide;

  &--cell {
    text-align: center;
  }
}
</style>
